import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function FeaturedArticles() {
  const featured = articles.slice(0, 6);

  return (
    <section className="py-20 md:py-28 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between gap-4 mb-14">
          <div>
            <span className="inline-block text-xs font-label text-primary-400 uppercase tracking-widest mb-3">
              精选文章
            </span>
            <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-50">
              深度解析推荐
            </h2>
          </div>
          <Link
            to="/category/reader-discussion"
            className="text-sm text-primary-400 hover:text-primary-300 transition-colors flex items-center gap-1 whitespace-nowrap"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {featured.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group block rounded-xl overflow-hidden bg-background-100 border border-background-300/30 hover:border-primary-500/30 transition-all duration-300 cursor-pointer"
            >
              <div className="aspect-[16/10] overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  title={`${article.title} - 邪娠娼馆世界观指南`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                />
              </div>
              <div className="p-5">
                <div className="flex items-center gap-3 mb-3">
                  <span className="text-xs text-primary-400 font-label bg-primary-500/10 px-2.5 py-0.5 rounded-full">
                    {article.tags[0]}
                  </span>
                  <span className="text-xs text-foreground-600">{article.readTime}</span>
                </div>
                <h3 className="text-base font-heading font-semibold text-foreground-100 mb-2 group-hover:text-primary-400 transition-colors line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2 mb-4">
                  {article.summary}
                </p>
                <div className="flex items-center justify-between text-xs text-foreground-600">
                  <span>{article.author}</span>
                  <span>{article.publishDate}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}